(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Sticky Header functionality
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header') || this;
      this.currentScrollTop = 0;
      this.threshold = 10;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.querySelector('details[open]') || this.contains(document.activeElement)) {
        this.reveal();
        return;
      }

      if (scrollTop <= 50) {
        this.reset();
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop + this.threshold) {
        requestAnimationFrame(() => this.hide());
      } else if (scrollTop < this.currentScrollTop - this.threshold) {
        requestAnimationFrame(() => this.reveal());
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.classList.add('shopify-section-header-hidden');
      this.classList.remove('shopify-section-header-sticky');
      this.closeDisclosures();
    }

    reveal() {
      this.classList.add('shopify-section-header-sticky');
      this.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    closeDisclosures() {
      this.querySelectorAll('details[open]').forEach(details => {
        details.removeAttribute('open');
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Keep hamburger menu drawer aligned to the left edge of the viewport
  function updateMenuDrawerScreenOffset() {
    const headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    const offset = Math.max(0, headerDrawer.getBoundingClientRect().left);
    headerDrawer.style.setProperty('--menu-drawer-screen-offset', `${offset}px`);
  }

  document.addEventListener('DOMContentLoaded', updateMenuDrawerScreenOffset);
  window.addEventListener('resize', updateMenuDrawerScreenOffset, { passive: true });

  // Mobile Drawer Injector for Secondary Links
  document.addEventListener('DOMContentLoaded', function() {
    const drawerNav = document.querySelector('.menu-drawer__navigation');
    const desktopSecondaryMenu = document.getElementById('DesktopSecondaryMenu');
    
    if (drawerNav && desktopSecondaryMenu) {
      const mobileMenuContainer = document.createElement('nav');
      mobileMenuContainer.classList.add('mobile-secondary-menu-container');
      mobileMenuContainer.setAttribute('aria-label', 'Secondary navigation');
      
      const clonedMenu = desktopSecondaryMenu.cloneNode(true);
      clonedMenu.id = 'MobileSecondaryMenu';
      clonedMenu.classList.remove('header__secondary-menu');
      clonedMenu.classList.add('mobile-secondary-menu');
      
      mobileMenuContainer.appendChild(clonedMenu);
      drawerNav.appendChild(mobileMenuContainer);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
